import { hydrateByUnit, normalizeId, sumLineItems } from '../components/expensesByUnit';

const csvMoney = n => {
  const num = Number(n);
  return Number.isFinite(num) && num ? num.toFixed(2) : 0;
};

export const unitMetaFromUnits = (units = []) => {
  const map = {};
  (units || []).forEach(u => {
    if (!u || u._id == null) return;
    const roomType = u.roomType || {};
    const property = roomType.property && typeof roomType.property === 'object' ? roomType.property : {};
    const id = String(u._id);
    const prev = map[id] || {};
    map[id] = {
      unitName: u.name || prev.unitName || id,
      roomTypeName: roomType.name || prev.roomTypeName || '',
      propertyName: property.name || prev.propertyName || '',
    };
  });
  return map;
};

const MONEY_KEYS = [
  'electricity',
  'water',
  'internet',
  'cleaning',
  'laundry',
  'service',
  'checkIn',
  'checkOut',
  'toiletry',
  'others',
];

const emptyAmounts = () => ({
  electricity: 0,
  water: 0,
  internet: 0,
  cleaning: 0,
  laundry: 0,
  service: 0,
  checkIn: 0,
  checkOut: 0,
  toiletry: 0,
  others: 0,
});

const amountsFromHydrated = row => {
  const othersHost = sumLineItems(row && row.othersByHost);
  const othersScalar = Number(row && row.others) || 0;
  return {
    electricity: Number(row && row.electricity) || 0,
    water: Number(row && row.water) || 0,
    internet: Number(row && row.internet) || 0,
    cleaning: Number(row && row.cleaning) || 0,
    laundry: Number(row && row.laundry) || 0,
    service: Number(row && row.service) || 0,
    checkIn: Number(row && row.checkIn) || 0,
    checkOut: Number(row && row.checkOut) || 0,
    toiletry: sumLineItems(row && row.toiletry),
    others: othersHost > 0 ? othersHost : othersScalar,
  };
};

const packageUnitsForRecord = (record, packages) => {
  const pkgId = normalizeId(record && record.servicePackage);
  const pkg = (packages || []).find(p => String(p._id) === String(pkgId));
  if (pkg && Array.isArray(pkg.units) && pkg.units.length) return pkg.units;
  const byUnit = (record && record.expenses && record.expenses.byUnit) || [];
  if (byUnit.length) return byUnit.map(row => row && row.unitId).filter(Boolean);
  const monthlyByUnit = (record && record.monthly && record.monthly.byUnit) || [];
  return monthlyByUnit.map(row => row && row.unitId).filter(Boolean);
};

const addMonthlyAmounts = (target, monthly) => {
  const next = target || emptyAmounts();
  const src = monthly || {};
  MONEY_KEYS.forEach(key => {
    next[key] = (Number(next[key]) || 0) + (Number(src[key]) || 0);
  });
  return next;
};

export const mapExpensesToCsvRows = ({ monthRows, packages, units, propertyName } = {}) => {
  const unitMeta = unitMetaFromUnits(units);
  const byUnit = {};
  (monthRows || []).forEach(record => {
    const packageUnits = packageUnitsForRecord(record, packages);
    if (!packageUnits.length) return;
    const hydrated = hydrateByUnit({
      packageUnits,
      hostUnits: units,
      recordExpenses: (record && record.expenses) || {},
    });
    hydrated.forEach(row => {
      const id = String(row.unitId);
      const prev = byUnit[id] || emptyAmounts();
      const next = amountsFromHydrated(row);
      MONEY_KEYS.forEach(key => {
        prev[key] = (Number(prev[key]) || 0) + (Number(next[key]) || 0);
      });
      byUnit[id] = prev;
    });
    ((record.monthly && record.monthly.byUnit) || []).forEach(row => {
      if (!row || row.unitId == null) return;
      byUnit[String(row.unitId)] = addMonthlyAmounts(byUnit[String(row.unitId)] || emptyAmounts(), row);
    });
  });

  return Object.keys(byUnit)
    .sort((a, b) => {
      const nameA = (unitMeta[a] && unitMeta[a].unitName) || a;
      const nameB = (unitMeta[b] && unitMeta[b].unitName) || b;
      return String(nameA).localeCompare(String(nameB));
    })
    .map(id => {
      const amounts = byUnit[id];
      const meta = unitMeta[id] || {};
      return {
        'Property Name': propertyName || meta.propertyName || '',
        'Room Type': meta.roomTypeName || '',
        'Unit Name': meta.unitName || id,
        Electricity: csvMoney(amounts.electricity),
        Water: csvMoney(amounts.water),
        Internet: csvMoney(amounts.internet),
        Cleaning: csvMoney(amounts.cleaning),
        Laundry: csvMoney(amounts.laundry),
        Service: csvMoney(amounts.service),
        'Check In': csvMoney(amounts.checkIn),
        'Check Out': csvMoney(amounts.checkOut),
        'Toiletry Sets': csvMoney(amounts.toiletry),
        Others: csvMoney(amounts.others),
        Currency: 'RM',
      };
    });
};
